// extracted by mini-css-extract-plugin
export default {"aPartner":"aPartnerCompanyOverseas_aPartner__XNJk8","logo":"aPartnerCompanyOverseas_logo__BnIjA","name":"aPartnerCompanyOverseas_name__agl+-"};